import fileReader from "./fileReader";

const PRODUCTION_ORDER_ERROR_CODE = 5046;

export function resolveProductionOrderError(
  error,
  translation,
  fallbackMessage,
) {
  const payload =
    error?.response?.data?.results ?? error?.response?.data ?? null;

  if (payload == null) {
    return fallbackMessage;
  }

  const [errorItem] = payload.errors ?? [];
  const reason = errorItem?.name;
  const template = reason ? translation.productionOrder.errors[reason] : null;

  if (!template) {
    return fallbackMessage;
  }

  return errorItem?.message
    ? template.replace("{{name}}", errorItem.message)
    : template;
}

export async function resolveProductionOrderBlobError(
  error,
  translation,
  fallbackMessage,
) {
  const data = error?.response?.data;

  if (!(data instanceof Blob)) {
    return resolveProductionOrderError(error, translation, fallbackMessage);
  }

  try {
    const content = await fileReader(data);
    const parsed = JSON.parse(content);

    return resolveProductionOrderError(
      { response: { data: parsed } },
      translation,
      fallbackMessage,
    );
  } catch (parseError) {
    return fallbackMessage;
  }
}

export function isProductionOrderError(error) {
  const payload =
    error?.response?.data?.results ?? error?.response?.data ?? null;

  return payload?.code === PRODUCTION_ORDER_ERROR_CODE;
}
